import { gql } from '@apollo/client';
import {
  IWorksheetAPIObject,
  WorksheetCategory,
} from 'spw-redux/modules/calculators/types';
import { WORKSHEET_FIELDS, WORKSHEET_ROW_FIELDS } from 'spw-api/fragments';
import { graphqlClient } from './utils';

export const fetchWorksheets = (scenarioIds: number[]) =>
  graphqlClient.query<{ getWorksheets: IWorksheetAPIObject[] }>({
    fetchPolicy: 'no-cache',
    query: gql`
      ${WORKSHEET_FIELDS}
      ${WORKSHEET_ROW_FIELDS}
      query FetchWorksheets($scenarioIds: [Int]) {
        getWorksheets(scenarioIds: $scenarioIds) {
          ...WorksheetFields
          scenarioId
          worksheetRows {
            ...WorksheetRowFields
          }
          notes {
            id
            note
            category
          }
        }
      }
    `,
    variables: {
      scenarioIds,
    },
  });

export const fetchTotalProgramWorksheet = (totalProgramId: number) =>
  graphqlClient.query({
    fetchPolicy: 'no-cache',
    query: gql`
      ${WORKSHEET_ROW_FIELDS}
      query FetchTotalProgramWorksheet {
          totalProgramWorksheet(totalProgramId: ${totalProgramId}) {
              totalProgramId
              rows {
                  ...WorksheetRowFields
              }
          }
      }
  `,
  });

export const fetchWorksheet = (scenarioId: number) =>
  graphqlClient.query({
    fetchPolicy: 'no-cache',
    query: gql`
      ${WORKSHEET_FIELDS}
      ${WORKSHEET_ROW_FIELDS}
      query FetchWorksheet {
          worksheet(scenarioId: ${scenarioId}) {
              ...WorksheetFields
              worksheetRows {
                  ...WorksheetRowFields
              }
              notes {
                  id
                  note
                  category
              }
              categories {
                  categoryId
                  visible
              }
              scenarioId
          }
      }`,
  });

export const updateChildSpaceTypePosition = (
  id: number,
  previousChildSpaceTypeId?: number,
  nextChildSpaceTypeId?: number
) =>
  graphqlClient.mutate({
    mutation: gql`
      mutation updateChildSpaceTypePosition(
        $id: ID!
        $previousChildSpaceTypeId: ID
        $nextChildSpaceTypeId: ID
      ) {
        childSpaceType: updateChildSpaceTypePosition(
          id: $id
          previousChildSpaceTypeId: $previousChildSpaceTypeId
          nextChildSpaceTypeId: $nextChildSpaceTypeId
        ) {
          id
          name
          clientFacingName
          projectId
          spaceTypeId
          unitsHigh
          rank
        }
      }
    `,
    variables: {
      id,
      previousChildSpaceTypeId,
      nextChildSpaceTypeId,
    },
  });

export const deleteCategoryWorksheetRowsFromProjectApi = (
  spaceTypeCategoryId: number
) =>
  graphqlClient.mutate({
    mutation: gql`
      mutation deleteCategoryWorksheetRowsFromProject(
        $spaceTypeCategoryId: ID!
      ) {
        deletedRows: deleteCategoryWorksheetRowsFromProject(
          spaceTypeCategoryId: $spaceTypeCategoryId
        ) {
          id
        }
      }
    `,
    variables: {
      spaceTypeCategoryId,
    },
  });

export const addRowsToProjectWorksheetsApi = ({
  spaceTypeCategoryId,
  projectSpaceTypeId,
  childWorksheetSpaceTypeId,
}: {
  spaceTypeCategoryId?: number;
  projectSpaceTypeId?: number;
  childWorksheetSpaceTypeId?: number;
}) =>
  graphqlClient.mutate({
    mutation: gql`
      mutation addRowsToProjectWorksheets(
        $spaceTypeCategoryId: ID
        $projectSpaceTypeId: ID
        $childWorksheetSpaceTypeId: ID
      ) {
        addRowsToProjectWorksheets(
          spaceTypeCategoryId: $spaceTypeCategoryId
          projectSpaceTypeId: $projectSpaceTypeId
          childWorksheetSpaceTypeId: $childWorksheetSpaceTypeId
        )
      }
    `,
    variables: {
      spaceTypeCategoryId,
      projectSpaceTypeId,
      childWorksheetSpaceTypeId,
    },
  });

export const updateWorksheetCategoryApi = ({
  worksheetId,
  categoryId,
  visible,
}: {
  worksheetId: number;
  categoryId: number;
  visible: boolean;
}) =>
  graphqlClient.mutate<{ worksheetCategory: WorksheetCategory }>({
    mutation: gql`
      mutation updateWorksheetCategory(
        $worksheetId: ID!
        $categoryId: ID!
        $visible: Boolean!
      ) {
        worksheetCategory: updateWorksheetCategory(
          worksheetId: $worksheetId
          categoryId: $categoryId
          visible: $visible
        ) {
          categoryId
          worksheetId
          visible
        }
      }
    `,
    variables: {
      worksheetId,
      categoryId,
      visible,
    },
  });
